import { DynamicFormControlLayout, serializable } from '@ng-dynamic-forms/core';
import { CustomDynamicSelectModel, CustomDynamicSelectModelConfig } from '../shared-models/custom-dynamic-select.model';

export const TYPE_CHIP_CHOICE_AUTOCOMPLETE = 'CHIP-CHOICE-AUTOCOMPLETE';

export interface ChipChoiceAutocompleteModelConfig<T> extends CustomDynamicSelectModelConfig<T> {
}

export class ChipChoiceAutocompleteModel<T> extends CustomDynamicSelectModel<T> {
  @serializable() readonly type: string = TYPE_CHIP_CHOICE_AUTOCOMPLETE;

  constructor(config: ChipChoiceAutocompleteModelConfig<T>, layout?: DynamicFormControlLayout) {
    super(config, layout);

    // make multiple by default
    if (typeof config.multiple !== 'boolean') {
      this.multiple = true;
    }

    // tell ng-dynamic-forms not to display additional label and errorMessages
    this.additional = {
      ...this.additional,
      isFormFieldControl: true
    };
  }
}
